"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var EVTaxCreditCard_1 = __importDefault(require("./Cards/EVTaxCreditCard"));
var GreatDealCard_1 = __importDefault(require("./Cards/GreatDealCard"));
var PriceDropCard_1 = __importDefault(require("./Cards/PriceDropCard"));
var ModalSections_1 = __importDefault(require("../../constants/ModalSections"));
var TagIds_1 = __importDefault(require("../../constants/TagIds"));
var TileDataContext_1 = require("../TileDataContext");
function MoreInfoPanel(_a) {
    var openTo = _a.openTo;
    var _b = (0, TileDataContext_1.useTileDataContext)().tileData, _c = _b.vehicleTags, vehicleTags = _c === void 0 ? [] : _c, previousPrice = _b.previousPrice;
    var showPriceDropCard = Boolean(previousPrice);
    var showEVCreditCard = vehicleTags.some(function (t) { return t.tagId === TagIds_1.default.EVCredit; });
    var showGreatDealCard = vehicleTags.some(function (t) { return t.tagId === TagIds_1.default.GreatDeal; });
    var evCreditCardRef = (0, react_1.useRef)(null);
    var greatDealCardRef = (0, react_1.useRef)(null);
    var priceDropCardRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        switch (openTo) {
            case ModalSections_1.default.EvTax:
                if (evCreditCardRef.current)
                    evCreditCardRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case ModalSections_1.default.GreatDeal:
                if (greatDealCardRef.current)
                    greatDealCardRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case ModalSections_1.default.NewPrice:
                if (priceDropCardRef.current)
                    priceDropCardRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            default:
                break;
        }
    }, [openTo]);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-24" },
        showPriceDropCard && (react_1.default.createElement("div", { ref: priceDropCardRef },
            react_1.default.createElement(PriceDropCard_1.default, null))),
        showGreatDealCard && (react_1.default.createElement("div", { ref: greatDealCardRef },
            react_1.default.createElement(GreatDealCard_1.default, null))),
        showEVCreditCard && (react_1.default.createElement("div", { ref: evCreditCardRef },
            react_1.default.createElement(EVTaxCreditCard_1.default, null)))));
}
exports.default = MoreInfoPanel;
//# sourceMappingURL=MoreInfoPanel.js.map